import { PsychologistSearchListParams } from '@/modules/Users/services/mapper/PatientsMapper/PsychologistSearchListMapper/PsychologistSearchListMapper.types'

export const INITIAL_FORM_DATA: PsychologistSearchListParams = {
  theme: '',
  theoreticalApproach: '',
  ageRange: '',
  gender: '',
  professional: '',
  availability: null,
  patientId: null,
  page: 1,
  itemsPerPage: 10,
  executeCount: true,
  searchByScreening: true,
}
